/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RemoteSession, RemoteSession$inboundSchema } from "./remotesession.js";

/**
 * Result type for the remote_sessions minted against a remote_session_client.
 */
export type ListOrganizationRemoteSessionsResult = {
  items: Array<RemoteSession>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionsResult$inboundSchema: z.ZodMiniType<
  ListOrganizationRemoteSessionsResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(RemoteSession$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listOrganizationRemoteSessionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListOrganizationRemoteSessionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationRemoteSessionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListOrganizationRemoteSessionsResult' from JSON`,
  );
}
